import { Box, Skeleton } from '@mui/material';

const AddCollaboratorsLoader = () => (
  <Box display="flex" flexDirection="column" justifyContent="center">
    <Skeleton height={56} width="100%" />
    <Box my={2}>
      <Skeleton height={40} width="100%" />
      <Skeleton height={40} width="100%" />
      <Skeleton height={40} width="100%" />
      <Skeleton height={40} width="100%" />
      <Skeleton height={40} width="100%" />
      <Skeleton height={40} width="100%" />
    </Box>
  </Box>
);

export default AddCollaboratorsLoader;
